import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class FactorySettings implements MutableValue {
  public isNew = false;

  constructor(
    private fFactoryId: string,
    private fIsEarlyArtworkAccessEnabled: boolean
  ) {
    if (
      fFactoryId === undefined ||
      fIsEarlyArtworkAccessEnabled === undefined
    ) {
      throw new Error(
        "Factory settings require a factory and artwork access value"
      );
    }
  }

  get id(): string {
    return this.fFactoryId;
  }

  get factoryId(): string {
    return this.fFactoryId;
  }

  get isEarlyArtworkAccessEnabled(): boolean {
    return this.fIsEarlyArtworkAccessEnabled;
  }
}
